import React from 'react';
import { Helmet } from 'react-helmet';
import Header from '../components/Header';
import Footer from '../components/Footer';

const NotFoundPage: React.FC = () => {
  return (
    <div className="page-wrapper">
      <Helmet>
        <title>Page Not Found | Giving For The Living</title>
        <meta name="description" content="The page you're looking for doesn't exist." />
      </Helmet>
      
      <Header />
      
      <main className="error-page">
        <div className="error-card">
          <div className="error-code">404</div>
          <h1 className="error-title">Page Not Found</h1>
          <p className="error-message">
            The page you're looking for doesn't exist or has been moved.
          </p>
          <a 
            href="https://givingfortheliving.com" 
            className="error-button"
          >
            Return to Home
          </a>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default NotFoundPage;
